module.exports = __webpack_public_path__ + "static/media/livestream-logo.f421f7e6.png";